export const ASIDE_BAR_WIDTH = 50;
export const BOLL_ID = 'boll';
export const BALL_CODE = 1;
export const CANVAS_MAIN = 'canvasMain';
export const CANVAS_CANONICAL = 'canvasCanonical';
export const CANVAS_SECOND = 'canvasSecond';

export const ENGINE_STATUS_STOPPED = 0;
export const ENGINE_STATUS_WORKING = 1;
export const ENGINE_STATUS_LOADING = 2;

export const GROUP_BY_PLAYER = 'player';
export const GROUP_BY_TEAM = 'team';
export const PLAYER_CODE = 0;
export const PLAYERS_ALL_CODE = 'ALL_PLAYERS';
export const INIT_SETUP = 'setup';
export const INIT_ROUTER = 'router';
export const INIT_HTTP = 'http';
export const INIT_THEME = 'theme';
export const ALL = 'all';
export const PENDING = 'pending';
export const UNKNOWN = 'unknown';
export const ENABLED = 'enabled';
export const DISABLED = 'disabled';
export const SUCCESS = 'success';
export const READY = 'ready';
export const FAILURE = 'failure';
export const UPLOADING = 'uploading';
export const NOT_STARTED = 'not_started'
export const STARTED = 'started'
export const PLAYERS_DETECTED = 'players_detected'
export const FIELD_KEYPOINTS_DETECTED = 'field_keypoints_detected'
export const TEAMS_DETECTED = 'teams_detected'
export const CANONICAL_VIEW_DETECTS_PROCESSED = 'canonical_view_detects_processed'
export const RAW_TRACKS_EXTRACTED = 'raw_tracks_extracted'
export const CANONICAL_VIEW_PROCESSED = 'canonical_view_processed'
export const TRACKS_PROCESSED = 'tracks_processed'
export const COMPLETED = 'completed'
export const MODAL_DELETE = 'delete';
export const MODAL_JOIN = 'join';
export const MODAL_SPLIT = 'split';
export const MODAL_SWAP = 'swap';
export const MODAL_TRIM = 'trim';

export const PLAYER_NUMBER = 'player_number';
export const PLAYER_NAME = 'player_name';
export const TRACK_ID = 'track_id';

export const PROGRESS = [ NOT_STARTED,
                          STARTED,
                          PLAYERS_DETECTED,
                          FIELD_KEYPOINTS_DETECTED,
                          TEAMS_DETECTED,
                          CANONICAL_VIEW_DETECTS_PROCESSED,
                          RAW_TRACKS_EXTRACTED,
                          CANONICAL_VIEW_PROCESSED,
                          TRACKS_PROCESSED,
                          SUCCESS,
                        ]
export const TRACKS_FILTER_INTERVAL = 'timeInterval';
export const TRACKS_FILTER_OUTFIT = 'outfit';
export const TRACKS_FILTER_TEAM = 'teamFilter';
export const TRACKS_GROUP = 'grouping';
export const TRACKS_HIDE = 'hide';
export const TRACKS_REVIEW = 'review';
export const TRACKS_SEARCH = 'search';
export const VIDEO_DEFAULT_TYPE = 0;
export const VIDEO_TV_TYPE = 1;
export const VIEW_DETECTS = 'detects';
export const VIEW_CANONICAL = 'canonical';
export const VIEW_FIELD = 'field';
export const VIEW_FRAMES = 'frames';
export const VIEW_VIDEO = 'raw';
export const VIEW_TRACKS = 'tracks';

export const JERSEY_BY_SEC = '1 sec';
export const JERSEY_CANONICAL = 'Сanonical';
export const JERSEY_ISSUE_POINTS= 'Issues';
export const JERSEY_NUMBERS = 'Numbers';
export const JERSEY_OVERVIEW = 'Overview';

export const TABLE_JERSEYS = 'Thumbnails';
export const TABLE_TRACKING = 'Tracking';

export const FIELD_MODELS = [
  {
    label: "30 key points",
    value: "30",
  },
  {
    label: "74 key points",
    value: "74",
  },
  {
    label: "117 key points",
    value: "117",
  },
  {
    label: "direct_camera_params",
    value: "direct_camera_params",
  }
];

export const PROJECT_PHASES = [
  {
    label: 'Fast analysis without tracking',
    value: 5,
  },
  {
    label: 'Full analysis',
    value: 8,
  },
];

export const TRACKING_MODELS = [
  {
    label: 'Regular',
    value: 'regular',
  },
  {
    label: 'Visual',
    value: 'visual',
  },
];

export const TRACKING_BACKENDS = [
  {
    label: 'Regular',
    value: false,
  },
  {
    label: 'DeepStream',
    value: true,
  },
];

export default {
  ASIDE_BAR_WIDTH,
  CANVAS_CANONICAL,
  CANVAS_MAIN,
  CANVAS_SECOND,
  INIT_SETUP,
  INIT_ROUTER,
  INIT_HTTP,
  INIT_THEME,
  JERSEY_BY_SEC,
  JERSEY_CANONICAL,
  JERSEY_ISSUE_POINTS,
  JERSEY_NUMBERS,
  JERSEY_OVERVIEW,
  ALL,
  PENDING,
  UNKNOWN,
  ENABLED,
  DISABLED,
  SUCCESS,
  READY,
  FAILURE,
  UPLOADING,
  NOT_STARTED,
  STARTED,
  PLAYERS_DETECTED,
  FIELD_KEYPOINTS_DETECTED,
  TEAMS_DETECTED,
  CANONICAL_VIEW_DETECTS_PROCESSED,
  RAW_TRACKS_EXTRACTED,
  CANONICAL_VIEW_PROCESSED,
  TRACKS_PROCESSED,
  COMPLETED,
  MODAL_DELETE,
  MODAL_JOIN,
  MODAL_SPLIT,
  MODAL_SWAP,
  MODAL_TRIM,
  PROGRESS,
  VIDEO_DEFAULT_TYPE,
  VIDEO_TV_TYPE,
  VIEW_DETECTS,
  VIEW_CANONICAL,
  VIEW_FIELD,
  VIEW_FRAMES,
  VIEW_VIDEO,
  VIEW_TRACKS,
};
